import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AdminDashboard from './components/AdminDashboard';
import UserTrackingPage from './components/UserTrackingPage';
import RouteDisplayPage from './components/RouteDisplayPage';
import './components/MapStyles.css'; 

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<UserTrackingPage />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/routes" element={<RouteDisplayPage />} />
      </Routes>
    </Router>
  );
}

export default App;
